export default "__VITE_ASSET__BzGHg6jB__"